/* eslint-disable consistent-return, react/jsx-no-bind */
import { Button, ButtonGroup } from "react-bootstrap";
import {
	CalendarIcon,
	ChevronRightIcon,
	DesktopComputerIcon,
	LocationMarkerIcon,
	UserCircleIcon
} from "@heroicons/react/outline";
import { format, utcToZonedTime } from "date-fns-tz";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useMemo } from "react";

import CourseHeaderFacilitatorActions from "../courses/components/CourseHeaderFacilitatorActions";
import EventPopoverButton from "./EventPopoverButton";
import MetaItem from "../../components/MetaItem";
import ShareClassButton from "../../components/ShareClassButton";

import { isInPersonEvent, isRemoteEvent } from "../../helpers/event";
import { getTimezone } from "../../helpers/dates";
import { hasRole } from "../../services/wp.user.service";

const timeZone = getTimezone();

const EventPopover = ({ event }) => {

	const inPast = useMemo(() => new Date() > event.start, []);
	const inPerson = useMemo(() => isInPersonEvent(event), []);
	const isOnline = useMemo(() => isRemoteEvent(event), []);

	return (
		<div className="event-popover-content">
			<div className="event-detail p-3">
				<h6 className="text-blue">
					{event.title}
				</h6>

				{event.subTitle ? <div className="mb-4 text-neutral3 fs-14">{event.subTitle}</div> : null}

				<MetaItem
					Icon={CalendarIcon}
					className="mb-3"
					label={format(utcToZonedTime(event.start, timeZone), "MMM do, h:mm a zzz", { timeZone })}
				/>

				{inPerson
					? <MetaItem Icon={LocationMarkerIcon} className="mb-3" label={event.location} />
					: null}

				{isOnline
					? <MetaItem Icon={DesktopComputerIcon} className="mb-3" label="Online with Video" />
					: null}

				{event.facilitator ? <MetaItem Icon={UserCircleIcon} label={event.facilitator} /> : null}

			</div>

			{hasRole(["facilitator", "staff", "administrator"])
				? (
					<ButtonGroup className="bg-neutral11 facilitator-actions w-100" size="sm">
						<CourseHeaderFacilitatorActions event={event} />
					</ButtonGroup>)
				: null}

			<footer className="bg-inovagray p-3">
				{!inPast && (
					<EventPopoverButton
						className={"mb-4 px-1 fs-14 w-100 border-1 border-neutral9"}
						course={event}
					/>
				)}

				<div className="d-flex justify-content-between">
					<Button
						as={Link}
						size="sm"
						to={`/class/${event.id}`}
						variant="link"
					>
						Find Out More
						<ChevronRightIcon className="i" />
					</Button>
					<ShareClassButton
						course={event}
						size="sm"
						text="Share"
						variant="link"
					/>
				</div>
			</footer>
		</div>
	);
};

EventPopover.propTypes = {
	event: PropTypes.shape({
		description: PropTypes.string,
		facilitator: PropTypes.string,
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		location: PropTypes.string,
		series: PropTypes.shape({
			id: PropTypes.number
		}),
		// eslint-disable-next-line react/forbid-prop-types
		start: PropTypes.object,
		subTitle: PropTypes.string,
		title: PropTypes.string.isRequired
	}).isRequired
};

export default EventPopover;
